import { connectRouter } from 'connected-react-router'
import { persistCombineReducers } from 'redux-persist'
import { fetchAppInfo } from '../actions/commons-actions'
import auth from './auth-reducer'
import password from './password-reducer'
import users from './users-reducer'
import rehydrate from './rehydrate-reducer'
import storeInfo from './store-info-reducer'
import batchImport from './batch-import-reducer'
import payApply from './pay-apply-reducer'
import transactions from './transactions-reducer'
import chat from './chat-reducer'
import news from './news-reducer'
import statistics from './statistics-reducer'
import settings from './settings-reducer'
import bonusCheck from './bonus-check-reducer'
import bonusSearch from './bonus-search-reducer'
import commons from './commons-reducer'

export const combinedReducers = (config, history) =>
  persistCombineReducers(config, {
    auth,
    password,
    users,
    rehydrate,
    storeInfo,
    batchImport,
    payApply,
    transactions,
    chat,
    news,
    statistics,
    settings,
    bonusCheck,
    bonusSearch,
    commons,
    router: connectRouter(history),
  })

export const initApp =
  ({ dispatch }) =>
  () => {
    fetchAppInfo(dispatch)
  }

const rootReducer = (config, history) => {
  const reducers = combinedReducers(config, history)
  return (state, action) => {
    if (action && action.type === 'CY_RESET_STATE') {
      return reducers(action.state, action)
    }
    return reducers(state, action)
  }
}

export default rootReducer
